import { del, patch, post, read } from '@/utils/request'
import type { BatchProcessingParams, BatchProcessingRes, DetailWithLogs, ListData } from 'bv-typings'
import type { MailSaleListItem } from '@/services/distributeMail/addressee'
import { paramsArray2Str, toggleTime } from '@/utils'


export type IMailAppealInfo = {
  id: string
  accountId: string	// 账户ID
  appealDate: string	// 日期
  businessType: number	// 业务类型
  advertiserCn: string	// Advertiser(中文)
  advertiserEn: string	// Advertiser(英文)
  agency: string	// 代理
  saleName: string	// 销售
  saleEmail: string
  settlement: string	// 结算主体
  feedback: string	// 反馈
  sendStatus: number	// 发送状态
}

export type IMailAppealListRes = ListData<IMailAppealInfo>

type IMailAppealListParams = {
  saleName: string
  sendStatus: number
  advertiserCn: string
  accountId: string
  settlement: string
  start: string
  end: string
}

async function getAppealList (params?: IMailAppealListParams) {
  return read<IMailAppealListRes> (
    'mail_distribution/blocked_appeals',
    toggleTime(params),
    // '查询列表失败'
  )
}

export type ICreateAppealParams = {

} & IMailAppealInfo

async function createAppeal (params: ICreateAppealParams) {
  return post<any> ('mail_distribution/blocked_appeals', paramsArray2Str(params), '新建申诉失败')
}

export type IEditAppealParams = {

} & Omit<IMailAppealInfo, 'accountId' | 'appealDate'>

async function editAppeal (params: IEditAppealParams, id: string) {
  return patch<any> ('mail_distribution/blocked_appeals', paramsArray2Str(params), '修改申诉失败', id)
}

async function getAppealDetail (id: string) {
  return read<DetailWithLogs<IMailAppealInfo>> ('mail_distribution/blocked_appeals', undefined, '获取申诉详情失败', id )
}

async function batchCreateAppeal (params: BatchProcessingParams<ICreateAppealParams>[]) {
  return post<BatchProcessingRes<ICreateAppealParams>> (
    'mail_distribution/blocked_appeals',
    params.map(item => paramsArray2Str(item)),
  )
}

async function batchEditAppeal (params: BatchProcessingParams<IEditAppealParams>[]) {
  return patch<BatchProcessingRes<IEditAppealParams>> (
    'mail_distribution/blocked_appeals',
    params.map(item => paramsArray2Str(item)),
  )
}

async function batchDeleteAppeal (ids: string[]) {
  return del<any> ('mail_distribution/blocked_appeals', ids, '批量删除申诉失败')
}

async function batchCommitAppeal (ids: string[]) {
  return post<any> ('mail_distribution/send_blocked_appeals', ids, '批量提交申诉失败')
}

async function searchAppealSale (saleName?: string ) {
  return read<MailSaleListItem[]> ('mail_distribution/blocked_appeals_search_sales', { saleName }, '获取销售（邮箱）失败' )
}

async function getAppealSaleList (params?: string) {
  const [ res ] = await searchAppealSale(params)
  return res?.map(({ saleName, saleEmail }) => ({ value: saleEmail, title: `${ saleName }【${ saleEmail }】` }))
}


export {
  getAppealList,
  createAppeal,
  editAppeal,
  batchDeleteAppeal,
  getAppealDetail,
  batchCreateAppeal,
  batchEditAppeal,
  batchCommitAppeal,
  searchAppealSale,
  getAppealSaleList,
}
